'use client'

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import handHoldingPhoneVertical from '../../../../public/assets/hand-holding-phone-vertical.jpg'
import ImageFirstSection from '../../../shared/components/ImageFirstSection'
import { colors } from '../../../shared/theme/colors'

const AboutSection: FC = () => (
  <ImageFirstSection
    imageSrc={handHoldingPhoneVertical}
    imageAltText="Tapping Mission Lane credit card"
    backgroundColor="green"
  >
    <Typography variant="h2" sx={{ color: colors.White }} className="mb-4 md:mb-6">
      About Mission Lane
    </Typography>
    <Typography variant="p1" sx={{ color: colors.Green[200] }} className="mb-6">
      We&apos;re expanding what&apos;s possible for those striving for a better financial future. We
      use data and technology to look beyond credit scores, seeing real people and real potential.
    </Typography>
    <Typography variant="p1" sx={{ color: colors.Green[200] }}>
      Mission Lane credit cards are designed to expand access. And because real progress requires
      more than just a line of credit, Mission Lane strives to deliver the clarity and proactive
      support customers need to move forward with confidence.
    </Typography>
  </ImageFirstSection>
)

export default AboutSection
